import React, { useState } from 'react';
import { Card, Table, Input, Button, Space, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import styles from './System.module.scss';

const { Search } = Input;

const KernelParams = ({ kernelParams }) => {
  const [, setSearchText] = useState('');
  const [filteredParams, setFilteredParams] = useState([]);
  const [isFiltered, setIsFiltered] = useState(false);

  // 커널 파라미터 파싱
  const parseKernelParams = (data) => {
    if (!data || data === 'N/A') return [];
    
    try {
      const params = [];
      const lines = data.trim().split('\n');
      
      lines.forEach(line => {
        if (line.includes('=')) {
          const [key, value] = line.split('=');
          params.push({
            key: key.trim(),
            value: value.trim(),
            full: line.trim(),
            keyIndex: key.trim()
          });
        }
      });
      
      return params;
    } catch (error) {
      console.error('Error parsing kernel params:', error);
      return [];
    }
  };

  const params = parseKernelParams(kernelParams);

  const handleSearch = (value) => {
    setSearchText(value);
    if (value) {
      const filtered = params.filter(param => 
        param.key.toLowerCase().includes(value.toLowerCase()) ||
        param.value.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredParams(filtered);
      setIsFiltered(true);
    } else {
      setFilteredParams([]);
      setIsFiltered(false);
    }
  };

  return (
    <Card 
      title={
        <div>
          커널 파라미터
          <Tooltip title="sysctl을 통해 설정된 커널 파라미터입니다.">
            <InfoCircleOutlined style={{ marginLeft: 8 }} />
          </Tooltip>
        </div>
      } 
      className={styles.systemCard}
      extra={
        <Space>
          <Search
            placeholder="파라미터 검색..."
            allowClear
            onSearch={handleSearch}
            style={{ width: 250 }}
          />
        </Space>
      }
    >
      {isFiltered && (
        <div className={styles.filterInfo}>
          <span>{filteredParams.length} 파라미터 찾음</span>
          <Button 
            type="link" 
            onClick={() => {
              setSearchText('');
              setFilteredParams([]);
              setIsFiltered(false);
            }}
          >
            필터 초기화
          </Button>
        </div>
      )}
      
      <Table 
        dataSource={isFiltered ? filteredParams : params}
        rowKey="keyIndex"
        pagination={{ pageSize: 10 }}
        columns={[
          { title: '파라미터', dataIndex: 'key', key: 'key', width: '40%' },
          { title: '값', dataIndex: 'value', key: 'value', width: '60%' }
        ]}
      />
    </Card>
  );
};

export default KernelParams;